import { render, staticRenderFns } from "./ContratoNew.vue?vue&type=template&id=5426c43e"
import script from "./ContratoNew.vue?vue&type=script&lang=ts"
export * from "./ContratoNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports